// extracted by mini-css-extract-plugin
export var modal = "_uc-0";
export var table = "_uc-1";